import { memo, useMemo } from 'react'
import { useRouter } from 'next/router'
import Link from 'next/link'
import styled from 'styled-components'
import { mq, getRelative, getP15_1 } from '@/styles'

const Section = styled.section`
  grid-column: 4 / span 3;
  padding: 0;

  ${mq.greaterThan('tablet')`
    align-items: flex-end;
    grid-column: 9 / span 4;
    grid-row: 1 / span 2;
  `}

  .list--pages {
    align-self: flex-end;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    list-style-type: none;
    margin-bottom: ${getRelative(10, 'mobile')};


    ${mq.greaterThan('tablet')`
      margin-bottom: 0;
    `}

    li {
      align-items: center;
      display: flex;
      margin-bottom: ${getRelative(15, 'mobile')};

      ${mq.greaterThan('tablet')`
        margin-bottom: ${getRelative(15, 'desktop')};
      `}

      &:last-child {
        margin-bottom: 0;
      }
    }

    a {
      color: ${({ theme }) => theme.colors.background};
      display: inline-block;
      font-family: ${({ theme }) => theme.fonts.basier};
      ${getP15_1()}
      font-size: ${getRelative(15, 'mobile')};
      opacity: 1;
      text-decoration: none;
      transition: 300ms opacity ease-out;

      &:hover {
        opacity: .4;
      }
    }
  }
`

export type TypePage = {
  readonly type: 'simple' | 'external',
  readonly title: string,
  readonly url: {
    page: 'content' | 'page' | 'products' | 'product' |'category',
    slug: {
      en?: null | string,
      es?: null | string,
      fr?: null | string,
      it?: null | string
    }
  }
}

const pathGenerator = {
  'content': (slug) => `/page/${slug}`,
  'simple': (slug) => `/page/${slug}`,
  'faqs': (slug) => slug ? `/faqs/${slug}` : '/faqs',
  'product': (slug) => `/product/${slug}`,
  'shop': (slug) => `/shop/${slug}`,
  'category': (slug) => `/shop/${slug}`
}

interface ISectionPages {
  pages: TypePage[]
}

const getPagesLink = (pages, locale) => pages.map((page, idx) => {
  const { type, title, url: { page:pageType, slug } } = page
  if(!title || title.indexOf('translation missing') !== -1) return null
  const path = pathGenerator[pageType](slug?.[locale])

  return (
    <li key={`footer-pages-${idx}`}>
      {type === 'external' ?
        <a href={slug[locale]} rel='noreferrer' target='_blank' title={title}>{title}</a>
        :
        <>
           {
            path.includes('cookies')  ? 
              <a href={path} title={title}>{title}</a>
            :
            <Link href={path || '/'}>
              <a title={title}>
                {title}
              </a>
            </Link>
          }
        </>
       
        
      }
    </li>
  )
})

export const SectionPages = memo(({ pages }:ISectionPages) => {
  const { locale } = useRouter() || { locale: 'es' }

  const Pages = useMemo(() => getPagesLink(pages, locale), [pages, locale])
  

  return (
    <Section>
      <ul className='list--pages'>
        {Pages}
      </ul>
    </Section>
  )
})
